import Event from 'Faster/model/Event';
import { default as uuidV4 } from 'uuid/v4';
import ServerDate from 'Faster/model/ServerDate';

class EventBuilder {
  private type: string;
  private revision: number;
  private ntpDate: Date;
  private _id: string = uuidV4();
  private _externalId?: string = null;
  private _dimensions: object = {};

  public constructor(type: string, revision: number) {
    this.type = type;
    this.revision = revision;
    this.ntpDate = ServerDate.now();
  }

  public id(id: string) {
    this._id = id;

    return this;
  }

  public externalId(externalId: string) {
    this._externalId = externalId;

    return this;
  }

  public dimension(key: string, value: string | number | boolean) {
    const validTypes = ['string', 'boolean', 'number'];

    if (!validTypes.includes(typeof value)) {
      console.warn('Invalid event dimension type. Only boolean, number and string are allowed.');

      return this;
    }

    this.addDimension(key, value);

    return this;
  }

  public dimensions(dimensions: object) {
    return Object.entries(dimensions).reduce((builder, [key, value]) => {
      return builder.dimension(key, value);
    }, this);
  }

  public build(): Event {
    return new Event(this._id, this.type, this.revision, this._dimensions, this.ntpDate, this._externalId);
  }

  private addDimension(key: string, value: string | number | boolean) {
    Object.assign(this._dimensions, {
      [key]: value,
    });
  }
}

export default EventBuilder;
